import { GET_MENU } from "../actions/types";

const initialState = [];

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_MENU:
			return action.payload;

		default:
			return state;
	}
};

export default reducer;
